/**
 * Dynamic Responsive Image Renderer
 * Replicates the Liquid responsive-image snippet for JS-rendered content
 */

(function() {
  'use strict';

  const DEFAULT_SIZES = [375, 770];
  const PLACEHOLDER_WIDTH = 20;

  function generateShopifySrcset(imageUrl, sizes = DEFAULT_SIZES) {
    if (!imageUrl) return '';

    const srcsetParts = sizes.map(width => {
      const resizedUrl = resizeShopifyImage(imageUrl, width);
      return `${resizedUrl} ${width}w`;
    });

    return srcsetParts.join(', ');
  }

  function resizeShopifyImage(url, width, height = null) {
    if (!url) return '';

    if (url.includes('cdn.shopify.com')) {
      const sizeParam = height ? `${width}x${height}` : `${width}x`;

      if (url.includes('_')) {
        return url.replace(/(_\d+x\d*)|(_\d+x)/, `_${sizeParam}`);
      }

      const extensionMatch = url.match(/\.(jpg|jpeg|png|gif|webp)(\?.*)?$/i);
      if (extensionMatch) {
        const ext = extensionMatch[1];
        const query = extensionMatch[2] || '';
        return url.replace(new RegExp(`\\.${ext}(\\?.*)?$`, 'i'), `_${sizeParam}.${ext}${query}`);
      }
    }

    return url;
  }

  function getPlaceholderUrl(imageUrl) {
    return resizeShopifyImage(imageUrl, PLACEHOLDER_WIDTH);
  }

  function createResponsiveImage(options = {}) {
    const {
      src,
      alt = '',
      className = '',
      sizes = DEFAULT_SIZES,
      lazy = true,
      priority = 'auto',
      aspectRatio = null
    } = options;

    if (!src) {
      return createPlaceholderImage(className);
    }

    const img = document.createElement('img');
    const srcset = generateShopifySrcset(src, sizes);

    if (lazy) {
      img.className = `lazyload ${className}`.trim();
      img.dataset.sizes = 'auto';
      img.dataset.src = getPlaceholderUrl(src);
      img.dataset.srcset = srcset;
      img.src = getPlaceholderUrl(src);
    } else {
      img.className = `no-blur ${className}`.trim();
      img.src = resizeShopifyImage(src, sizes[0]);
      img.srcset = srcset;
      img.sizes = '(max-width: 768px) 50vw, 33vw';
      img.loading = 'eager';
    }

    img.alt = alt;
    img.fetchPriority = priority;

    if (aspectRatio) {
      const [w, h] = aspectRatio.split(':').map(Number);
      if (w && h) {
        img.width = w;
        img.height = h;
      }
    }

    return img;
  }

  function createPlaceholderImage(className = '') {
    const div = document.createElement('div');
    div.className = `thb-placeholder ${className}`.trim();
    div.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525.5 525.5">
        <path d="M324.5 212.7H203c-1.6 0-2.8 1.3-2.8 2.8V308c0 1.6 1.3 2.8 2.8 2.8h121.6c1.6 0 2.8-1.3 2.8-2.8v-92.5c0-1.5-1.3-2.8-2.9-2.8zm1.1 95.3c0 .6-.5 1.1-1.1 1.1H203c-.6 0-1.1-.5-1.1-1.1v-92.5c0-.6.5-1.1 1.1-1.1h121.6c.6 0 1.1.5 1.1 1.1V308z"/>
        <path d="M210.4 299.5H240v.1s.1 0 .2-.1h75.2c.6 0 1.1-.5 1.1-1.1v-63.2c0-.6-.5-1.1-1.1-1.1H210.4c-.6 0-1.1.5-1.1 1.1v63.2c0 .6.5 1.1 1.1 1.1zm29.4-1.7l-15.2-15.2 15.2-15.2v30.4zm1.2-30.9l10.6 10.6-10.6 10.6v-21.2zm1.8-.4l14.5 14.5-14.5 14.5V266.5zm18-10.7l15.6 15.6-15.6 15.6v-31.2zm1.7 0h32.9l-16.4 16.4-16.5-16.4zm34.6 1.8v29.2l-14.6-14.6 14.6-14.6zm0 31.3l-16.3 16.3h-32.6l16.3-16.3h32.6zm-34.3 16.3l-14.5-14.5 14.5-14.5v29zm-1.8.4l-15.6-15.6 15.6-15.6v31.2zm-19.4-.4l-10.6-10.6 10.6-10.6v21.2zm-12.4-10.6l15.2 15.2h-30.4l15.2-15.2zm-16.9 16.9h30.4l-15.2 15.2-15.2-15.2zm32.2 0l16.3-16.3 16.3 16.3h-32.6z"/>
      </svg>
    `;
    return div;
  }

  function triggerLazyLoad() {
    if (typeof window.lazySizes !== 'undefined') {
      window.lazySizes.autoSizer.checkElems();
    }
  }

  window.ResponsiveImageDynamic = {
    create: createResponsiveImage,
    createPlaceholder: createPlaceholderImage,
    resize: resizeShopifyImage,
    generateSrcset: generateShopifySrcset,
    triggerLazyLoad: triggerLazyLoad
  };

})();
